import { NgModule } from '@angular/core';

import { TicketsPageRoutingModule } from './tickets-routing.module';
import { TicketService } from 'ticket-sdk';
import { TicketsPage } from './tickets.page';
import { SharedModule } from '@app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { UpdateLicensePlateNumberPage } from './update-license-plate-number/update-license-plate-number.page';

@NgModule({
  imports: [
    SharedModule,
    ReactiveFormsModule,
    TicketsPageRoutingModule
  ],
  declarations: [TicketsPage, UpdateLicensePlateNumberPage],
  providers: [TicketService],
})
export class TicketsPageModule {}
